import { calculateInitialPosition } from '@/components/SearchAssistant/helpers/ui';
import { useKeyboardShortcuts } from '@/hooks/useKeyboardShortcuts';
import { searchAssistantUIStore } from '@/stores/searchAssistantStore';
import { Button, Typography } from '@mui/material';
import { useCallback, useRef } from 'react';

const styles = {
  triggerButton: {
    cursor: 'pointer',
    padding: 0,
    height: '100%',
    borderRadius: '0.25rem',
    backgroundImage: (theme) =>
      `linear-gradient(135deg, ${theme.palette.baseColors.skyBlue.c100}, ${theme.palette.baseColors.infoBlue.c100})`,
  },
  label: {
    position: 'relative',
    zIndex: 12,
    fontWeight: 700,
    display: 'inline-block',
    padding: (theme) => theme.spacing(0.5, 1.5),
    color: (theme) => theme.palette.common.white,
    textTransform: 'uppercase',
  },
};

export const SearchAssistantTriggerButton = () => {
  const buttonRef = useRef(null);
  const toggleOpen = searchAssistantUIStore.use.toggleOpen();
  const setPosition = searchAssistantUIStore.use.setPosition();
  const hasBeenOpened = searchAssistantUIStore.use.hasBeenOpened();
  const isOpen = searchAssistantUIStore.use.isOpen();
  const size = searchAssistantUIStore.use.size();
  const renderTriggerButton = searchAssistantUIStore.use.renderTriggerButton();
  const isSidebarOpen = searchAssistantUIStore.use.isSidebarOpen();

  useKeyboardShortcuts({
    Escape: () => {
      if (isSidebarOpen) {
        searchAssistantUIStore.getState().toggleSidebar();
        return;
      }

      if (isOpen) {
        toggleOpen();
      }
    },
    '$mod+K': (event) => {
      event.preventDefault();
      toggleOpen();
    },
  });

  const handleClick = useCallback(() => {
    if (!hasBeenOpened && !isOpen && buttonRef.current) {
      const buttonRect = buttonRef.current.getBoundingClientRect();
      setPosition(calculateInitialPosition(buttonRect, size));
    }
    toggleOpen();
  }, [hasBeenOpened, isOpen, size, toggleOpen, setPosition]);

  if (!renderTriggerButton) {
    return null;
  }

  return (
    <Button ref={buttonRef} onClick={handleClick} sx={styles.triggerButton}>
      <Typography variant="caption" sx={styles.label}>
        Search Assistant
      </Typography>
    </Button>
  );
};
